// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'normalize.css/normalize.css'
import './assets/css/common.less'
// import './assets/css/animate.min.css'
import 'vant/lib/index.css';

Vue.config.productionTip = false

import less from 'less'
Vue.use(less)

import AOS from 'aos'
import 'aos/dist/aos.css'
Vue.use(AOS)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js